module.exports = __webpack_public_path__ + "static/media/100_10.56d054ff.jpg";